/**
 * Checks if provided passwords match
 */
export default function validatePassword(password: string, confirmPassword: string): boolean {
    return (password === confirmPassword) && confirmPassword.length >= 6
}
